<div class="listings-container">
  <input (keyup)="search($event)" placeholder="search instruments...." type="search" >
  <span> - OR - </span>
  <input (change)="trade.emit($event?.target.value)" placeholder="symbol i.e AAPL" type="text" >
</div>

<kt-settings-instrument-list (view)="trade.emit($event?.symbol)"  [instruments]="instruments" ></kt-settings-instrument-list>
